import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../Assets/WebsiteCss/Home.css";
import servicesData from "../data/servicesData";
import projectsData from "../data/projectsData";
import aboutImage from "../Assets/images/Home.png";
import Header from "./Header";

function Home() {
  const navigate = useNavigate();
  const aboutSectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const strip = entry.target.querySelector(".animate-strip");
          if (strip) strip.classList.add("animated");
          observer.disconnect(); // animate once
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      },
    );

    if (aboutSectionRef.current) {
      observer.observe(aboutSectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header />

      {/* About */}
      <section id="about" className="about" ref={aboutSectionRef}>
        <div className="container">
          <div className="about-content">
            <div className="about-image">
              <img src={aboutImage} alt="about" />
              <div className="experience-badge">
                <span className="years">15+</span>
                <span className="label">Years Experience</span>
              </div>
            </div>

            <div className="about-text">
              <h2 className="section-title ">About R K Constructions</h2>

              <p className="about-description">
                Welcome to <strong>R K Constructions</strong>, your trusted
                partner in civil engineering and construction excellence. Led by
                qualified civil engineers and skilled contractors, we ensure
                unmatched quality and professionalism.
              </p>

              <div className="about-features">
                {[
                  "Licensed Civil Engineers",
                  "Quality Materials",
                  "On-Time Delivery",
                  "Transparent Pricing",
                ].map((item, i) => (
                  <div key={i} className="feature-item">
                    <span className="feature-icon">✓</span>
                    <span className="feature-text">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="services">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Services</h2>
            <p className="section-subtitle">
              Comprehensive construction solutions
            </p>
          </div>

          <div className="services-grid">
            {servicesData.map((s) => (
              <div
                key={s.slug}
                className="service-card"
                onClick={() => navigate(`/services/${s.slug}`)}
              >
                <img src={s.img} alt={s.title} />
                <h3 className="service-title">{s.title}</h3>
                <p className="service-description">{s.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects */}
      <section id="projects" className="projects">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Work</h2>
            <p className="section-subtitle">
              Showcasing our commitment to quality
            </p>
          </div>

          <div className="projects-grid">
            {projectsData.map((p, i) => (
              <div key={p._id || i} className="project-card">
                <div
                  className="project-image"
                  onClick={() => navigate(`/projects`)}
                >
                  <img src={p.img} alt={p.title} />
                  <div className="project-overlay">
                    <span className="project-category">{p.category}</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3 className="project-title">{p.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
